import { subscriptions as subscriptionsConstants } from 'src/constants';

export default subscriptionsConstants.PAYMENT_PROVIDER.PATHS;
